<template>
    <div class="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <h1 class="text-3xl font-bold text-gray-900 mb-8">Terms of Use</h1>

        <div class="prose prose-slate max-w-none">
            <p class="mb-4 italic">Last Updated: 02/01/2026</p>

            <h2 class="mt-8 mb-1 font-semibold">1. Acceptance of Terms</h2>
            <p>
                By accessing and using ClaimReady ("the Service"), you agree to accept and comply with these Terms of
                Use. If you do not agree, you should not use the Service.
            </p>

            <h2 class="mt-8 mb-1 font-semibold">2. No Legal Advice</h2>
            <UAlert icon="i-heroicons-exclamation-triangle" color="error" variant="soft" title="Important Disclaimer"
                class="mb-6 not-prose">
                <template #description>
                    ClaimReady is a documentation tool, not a law firm or insurance agency. The reports generated by
                    this Service are intended to assist in the claims process but <strong>do not guarantee</strong>
                    coverage or reimbursement by your insurance provider. We do not provide legal or insurance advice.
                </template>
            </UAlert>

            <h2 class="mt-8 mb-1 font-semibold">3. User Responsibilities</h2>
            <p>
                You are solely responsible for:
            </p>
            <ul class="mb-4 list-disc list-inside">
                <li class="pl-4">The accuracy, truthfulness, and completeness of the data you enter.</li>
                <li class="pl-4">Ensuring you have the right to photograph and document the items in your inventory.
                </li>
                <li class="pl-4">Retaining your specific insurance policy documents and understanding your coverage
                    limits.</li>
                <li class="pl-4"><strong>Backing up your data.</strong> Because we do not store your data on our
                    servers,
                    clearing
                    your browser's cache or local storage will permanently delete your inventory. We are not responsible
                    for data loss caused by browser maintenance or device failure.</li>
            </ul>
            <p class="mb-4">If you purchased and generated a report, you are responsible for storing that report in a
                safe place.
                We do not store your reports on our servers.</p>

            <h2 class="mt-8 mb-1 font-semibold">4. Service Availability</h2>
            <p>
                We strive for 100% uptime, but we cannot guarantee that the Service will be uninterrupted or error-free.
                We reserve the right to modify or discontinue the Service at any time (though we will always aim to
                fulfill paid report generation requests).
            </p>

            <h2 class="mt-8 mb-1 font-semibold">5. Refunds</h2>
            <p>
                Due to the immediate delivery of the digital report, all sales are final once the report has been
                generated. If you experience technical issues preventing report generation, please contact support for
                assistance.
            </p>

            <h2 class="mt-8 mb-1 font-semibold">6. Limitation of Liability</h2>
            <p>
                In no event shall ClaimReady be liable for any indirect, incidental, special, or consequential damages
                arising out of your use of the Service, including but not limited to denied insurance claims or data
                loss resulting from local browser storage clearing.
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
definePageMeta({
    layout: 'default'
})
</script>
